import {CentralPanelBody} from './components/central-panel-body';
import {CentralPanelHeader} from './components/central-panel-header';
import {CentralPanelRoot} from './components/central-panel-root';

export const CentralPanel = {
	Root: CentralPanelRoot,
	Header: CentralPanelHeader,
	Body: CentralPanelBody,
};
